import { extractLocale } from './locale-extraction.js';
import { templateFieldKey, templateFieldLabel } from './form-field-answer.js';
/** Captions come only from the captured installed definition/declaration, never technical keys. */
export function evidenceReportContentCaption(profile, key, locale) {
    const visit = (value) => {
        if (!value || typeof value !== 'object')
            return '';
        if (Array.isArray(value)) {
            for (const item of value) {
                const label = visit(item);
                if (label)
                    return label;
            }
            return '';
        }
        const field = value;
        if (templateFieldKey(field) === key && extractLocale(field.label, locale))
            return templateFieldLabel(field, locale);
        for (const child of Object.values(value)) {
            const label = visit(child);
            if (label)
                return label;
        }
        return '';
    };
    const caption = visit(profile?.form_definition?.sections);
    if (caption)
        return caption;
    const requirement = profile?.declaration.requirements.find((r) => r.supplemental_key === key || r.form_field_ids?.includes(key));
    return extractLocale(requirement?.title, locale);
}
//# sourceMappingURL=evidence-report-captions.js.map